import { render } from "./SystemSettings.vue?vue&type=template&id=5fcb56ac&scoped=true&ts=true"
import script from "./SystemSettings.vue?vue&type=script&lang=ts"
export * from "./SystemSettings.vue?vue&type=script&lang=ts"

import "./SystemSettings.vue?vue&type=style&index=0&id=5fcb56ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcb56ac"]])

export default __exports__